import React from 'react';

const Slider = ({ defaultValue, max, step, onValueChange, className }) => (
  <input
    type="range"
    min="1"
    max={max}
    step={step}
    defaultValue={defaultValue}
    onChange={(e) => onValueChange([parseInt(e.target.value)])}
    className={className}
  />
);

export { Slider };
